import { useQuery, useMutation } from "@tanstack/react-query";
import { apiClient } from "api/apiClient.ts";
export const useSignUp = () => {
  return useMutation({
    mutationFn: async (formData: any) => {
      const { data } = await apiClient.post("/auth/register", formData);
      return data;
    },
  });
};
export const useLogin = () => {
  return useMutation({
    mutationFn: async ({ email, password }: any) => {
      const { data } = await apiClient.post("/auth/login", { email, password });
      return data;
    },
  });
};
export const useUpdateUser = () => {
  return useMutation({
    mutationFn: async (userData: any) => {
      const { data } = await apiClient.patch("/user/updateMyInfo", userData);
      return data;
    },
  });
};
export const useCreateOrder = () => {
  return useMutation({
    mutationFn: async (orderData: any) => {
      const { data } = await apiClient.post("/orders/create", orderData);
      return data;
    },
  });
};
export const useGetOrders = () => {
  return useQuery({
    queryKey: ["orders"],
    queryFn: async () => {
      const { data } = await apiClient.get("/orders/my-orders");
      return data.data.orders;
    },
  });
};
export const useGetMosques = () => {
  return useQuery({
    queryKey: ["mosques"],
    queryFn: async () => {
      const { data } = await apiClient.get("/mosques");
      return data.data.mosques;
    },
  });
};
